(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hero-video"] && !Shopify.designMode) return;
  try {
    (() => {
    const desktopQuery = window.matchMedia('(min-width: 750px)');
    const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

    const connectionAllowsVideo = () => {
      const conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      if (!conn) return true;
      if (conn.saveData) return false;
      const type = conn.effectiveType;
      return type !== 'slow-2g' && type !== '2g' && type !== '3g';
    };

    const canAutoplay = (video) => {
      if (motionQuery.matches) return false;
      if (!connectionAllowsVideo()) return false;
      if (desktopQuery.matches) return true;
      return video.hasAttribute('data-mobile-autoplay');
    };

    const setPlayingState = (wrapper, isPlaying) => {
      if (!wrapper) return;
      wrapper.classList.toggle('is-playing', isPlaying);
      const button = wrapper.querySelector('[data-hero-video-play]');
      const label = isPlaying ? button?.dataset.labelPause : button?.dataset.labelPlay;
      if (label) button.setAttribute('aria-label', label);
    };

    const playVideo = (video) => {
      const wrapper = video.closest('.deferred-bg-video');
      let sourceAttached = false;

      video.querySelectorAll('source[data-video-source]').forEach((source) => {
        if (!source.getAttribute('src')) {
          source.setAttribute('src', source.dataset.videoSource);
          sourceAttached = true;
        }
      });

      // Reloading resets currentTime, so only load when the source was just attached; resume keeps position
      if (sourceAttached) video.load();
      const playPromise = video.play();
      if (playPromise && typeof playPromise.then === 'function') {
        playPromise.then(() => setPlayingState(wrapper, true)).catch(() => {});
      } else {
        setPlayingState(wrapper, true);
      }
    };

    const pauseVideo = (video) => {
      video.pause();
      setPlayingState(video.closest('.deferred-bg-video'), false);
    };

    const whenIdle = (callback, timeout) => {
      if ('requestIdleCallback' in window) {
        requestIdleCallback(callback, { timeout });
      } else {
        setTimeout(callback, Math.min(timeout, 1));
      }
    };

    const afterWindowLoad = (callback) => {
      if (document.readyState === 'complete') {
        callback();
        return;
      }
      window.addEventListener('load', callback, { once: true });
    };

    const setupHeroVideos = () => {
      document.querySelectorAll('[data-hero-video]').forEach((video) => {
        const wrapper = video.closest('.deferred-bg-video');
        const playButton = wrapper?.querySelector('[data-hero-video-play]');

        if (canAutoplay(video)) {
          playButton?.setAttribute('hidden', '');

          if (desktopQuery.matches) {
            whenIdle(() => {
              if (canAutoplay(video)) playVideo(video);
            }, 2500);
            return;
          }

          // Mobile autoplay path: wait for window load so poster wins LCP.
          afterWindowLoad(() => {
            whenIdle(() => {
              if (canAutoplay(video)) playVideo(video);
            }, 2000);
          });
          return;
        }

        // Mobile (or reduced connection/motion): keep poster, wait for tap.
        pauseVideo(video);
        playButton?.removeAttribute('hidden');
      });
    };

    document.addEventListener(
      'click',
      (event) => {
        const playButton = event.target.closest('[data-hero-video-play]');
        if (!playButton) return;

        event.preventDefault();
        event.stopPropagation();

        const wrapper = playButton.closest('.deferred-bg-video');
        const video = wrapper?.querySelector('[data-hero-video]');
        if (!video) return;

        if (wrapper.classList.contains('is-playing')) {
          pauseVideo(video);
        } else {
          playVideo(video);
        }
      },
      true
    );

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setupHeroVideos, { once: true });
    } else {
      setupHeroVideos();
    }

    desktopQuery.addEventListener('change', setupHeroVideos);
  })();
  } catch(e) { console.error(e); }
})();

})();
